import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../components'
import { selfCenter } from '../../styles'

export const Unauthorized: React.FC = () => {
    const navigate = useNavigate()

    return (
        <div className={`${selfCenter} flex flex-col items-center justify-center text-center gap-2`}>
            <div className="flex flex-col gap-2">
                <h1 className="text-3xl font-bold text-danger-600">Access Denied</h1>
                <p className="text-gray-700 dark:text-gray-300">
                    You do not have permission to view this page.
                </p>
            </div>
            <Button type="button" variant="solid" color="primary" onClick={() => navigate('/')}>
                Go back to Home
            </Button>
        </div>
    )
}
